import { useQuery } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { postAdvisorDetail } from "web_myplann/Infrastructure/ApiOld/Api";

export const useAdvisorDetailQuery = (id?: string) =>
	useQuery({
		queryKey: AdvisorKeys.detail(id ?? ""),
		queryFn: () => postAdvisorDetail({ id: id ?? "" }),
		enabled: Boolean(id),
		select: (resp) => (resp?.status === 200 ? resp.data?.data : undefined),
	});
